import { useCallback, useEffect, useState } from "react";

import { IgAutocomplete, IgTextField } from "@intelligems/ig-theme";
import { type AutocompleteRenderInputParams, useTheme } from "@mui/material";

const sizes = ["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px"];

type FontSizeSelectProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  title?: string;
};

export const FontSizeSelect = ({
  value,
  onChange,
  disabled,
  title,
}: FontSizeSelectProps) => {
  const theme = useTheme();
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const commit = (val: string) => {
    const normalized = val.match(/^\d+$/) ? `${val}px` : val;
    if (!/^\d+px$/.test(normalized)) {
      setInputValue(value || "");
      return;
    }
    onChange(normalized);
    setInputValue(normalized);
  };

  const renderInput = useCallback(
    (params: AutocompleteRenderInputParams) => (
      <IgTextField
        {...params}
        title={title}
        variant="outlined"
        size="small"
        sx={{
          width: 70,
          // I'll comment these out for now as this branch is not using the
          // RichTextEditor yet, so I cannot test which styles are needed
          // "& .MuiOutlinedInput-root": {
          //   height: 28,
          //   borderRadius: "8px",
          //   padding: "0 8px !important",
          //   "& .MuiOutlinedInput-notchedOutline": {
          //     border: "none",
          //   },
          //   "&:hover": {
          //     backgroundColor:
          //       theme.igBackgroundColors.interactive.neutral.hover,
          //   },
          // },
          // "& .MuiInputBase-input": {
          //   fontSize: 14,
          //   padding: "0 !important",
          // },
        }}
      />
    ),
    [title]
  );

  return (
    <IgAutocomplete
      freeSolo
      disableClearable
      filterOptions={(options: string[]) => options}
      disabled={disabled}
      options={sizes}
      inputValue={inputValue}
      onInputChange={(_e, newValue, reason) => {
        if (reason === "input") {
          setInputValue(newValue);
        } else if (reason === "reset") {
          setInputValue(newValue);
          commit(newValue);
        }
      }}
      onChange={(_e, newValue: string) => commit(newValue)}
      onBlur={() => {
        if (inputValue && inputValue !== value) {
          commit(inputValue);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && inputValue) {
          commit(inputValue);
        }
      }}
      slotProps={{
        popper: { sx: { zIndex: 1500 } },
        paper: { sx: { borderRadius: "8px" } },
      }}
      renderInput={renderInput}
    />
  );
};
